<template>
  <el-dialog
    title="选择项目"
    :visible.sync="propsData.visible"
    :close-on-click-modal="false"
    class="topDialog chooseProjectDialog"
    @close="closeDialog()"
    :close-on-press-escape="false">
    <div class="searchArea" style="margin-top:0;">
      <el-form
        label-position="left"
        size="small"
        label-width="80px"
        class="searchForm"
        :inline="true"
        @submit.native.prevent>
        <el-form-item label="关键字:">
          <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="text" class="defaultBtn" @click="searchTable">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="dialog_tableMain">
      <div class="dialog_tableContent" id="tableContent">
        <el-table :data="dataList" border stripe>
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column prop="serialNumber" width="150" label="项目编号"></el-table-column>
        <el-table-column prop="name" label="项目名称">
          <template slot-scope="props">
            <el-button
              type="text"
              size="mini"
              @click="chooseData(props.row)">{{props.row.name}}</el-button>
              <span style="color:red" v-if="props.row.removed">（已停用）</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态" width="120"></el-table-column>
        <el-table-column prop="ownerUserName" label="负责人" width="120"></el-table-column>
        <!-- <el-table-column prop="contractPrice" label="签约金额" width="120"></el-table-column> -->
      </el-table>
      </div>
       <div class="dialog_tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"></el-pagination>
      </div>
    </div>
   
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="propsData.visible=false">取消</el-button>
    </div>

  </el-dialog>
</template>
<script>
export default {
  name: "departmentName",
  components: {},
  props: ["propsData"],
  data() {
    return {
      dataList: [],
      defaultTableHeight: window.Glob.defaultTableHeight,
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: "",
          includeRemoved:false
         // statusValueArray: "0,1,2,3"
        }
      }
    };
  },

  mounted() {
  //  this.getDataList();
  },
  methods: {
    show(){
       this.propsData.visible = true;
       this.getDataList();
    },

    getDataList() {
      if(this.propsData.includeRemoved != undefined && this.propsData.includeRemoved != null)
      {
        this.listQuery.Parameters.includeRemoved = this.propsData.includeRemoved;
      }
      this.$projectApi.getProjectList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.dataList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    searchTable() {
      this.getDataList();
    },
    chooseData(args) {
      this.$emit("chooseProjectCallback", args);
      this.propsData.visible = false;
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getDataList();
    },
    closeDialog() {
      this.listQuery.Parameters.keyword = "";
      this.propsData.visible = false;
      document.getElementById('tableContent').scrollTop = 0;
      
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

.chooseProjectDialog .el-dialog{
    top: 2vh !important;
    bottom: 2vh !important; 
    left: 10% !important;
    right: 10% !important;
    width: 850px !important;
    height: 550px !important;
}

</style>


// WEBPACK FOOTER //
// src/views/common/chooseProject.vue